@if (showDynamicMessages()) {
    @for (message of notificationService.footerMessages(); track message) {
        <woa-footer-message [message]="message"></woa-footer-message>
    }
}
<ng-content select="woa-footer-message"></ng-content>
<ng-content select="[slot=messages]"></ng-content>
